<div *ngIf="timer$ | async as start; else defaultTimer">{{ start | parseMsAsDuration: true }}</div>
<ng-template #defaultTimer>
  <div>00:00:00</div>
</ng-template>
